<template>
    <v-stepper-step
        id='stepper-step'
        class="habiteo-body-2 export-step pb-4"
        :class='{
            "is-complete": currentStep >= stepId,
            "is-not-complete": currentStep < stepId
        }'
        :complete="currentStep > stepId"
        :edit-icon="'$complete'"
        :key="`step-${stepId}`"
        :step="stepId"
        :editable="currentStep > stepId"
    >
        {{ step }}
    </v-stepper-step>
</template>

<script>
    export default {
        name: 'StepSummaryItem',
        props: {
            currentStep: {
                type: Number,
                required: true
            },
            stepId: {
                type: Number,
                required: true
            },
            step: {
                type: String,
                required: true
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/components/StepSummaryItem.vue